import request from '@/utils/request'

// 查询发现-帖子列表
export function listDiscoveryPost(query) {
  return request({
    url: '/discovery/discovery/post/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现-帖子分页
export function pageDiscoveryPost(query) {
  return request({
    url: '/discovery/discovery/post/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现-帖子详细
export function getDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/detail',
    method: 'get',
    params: data
  })
}

// 新增发现-帖子
export function addDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/add',
    method: 'post',
    data: data
  })
}

// 修改发现-帖子
export function updateDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/edit',
    method: 'post',
    data: data
  })
}

// 删除发现-帖子
export function delDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/delete',
    method: 'post',
    data: data
  })
}

// 批量通过帖子
export function batchPassDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/batchPass',
    method: 'post',
    data: data
  })
}

// 批量拒绝帖子
export function batchRejectDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/batchReject',
    method: 'post',
    data: data
  })
}

// 批量通过帖子
export function batchRecommendDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/batchRecommend',
    method: 'post',
    data: data
  })
}

// 批量通过帖子
export function batchCancelRecommendDiscoveryPost(data) {
  return request({
    url: '/discovery/discovery/post/batchCancelRecommend',
    method: 'post',
    data: data
  })
}